import classNames from "classnames";
import SimpleImage from "../ImageOrVideo/SimpleImage";
import "./style.scss";

const GenericSlideThumb = ({ image, label, isActive, onClick }) => {
  return (
    <div
      className={classNames("slide-thumb", {
        active: isActive
      })}
      onClick={onClick}
    >
      <SimpleImage imageSrc={image} className="slide-thumb-bkg" />
      <div className="slide-thumb-label">
        <div>{label}</div>
      </div>
      <svg
        className="slide-thumb-arrow"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 2 1"
      >
        <path d="M1,0L2,1L0,1Z" fill="#ffffff" />
      </svg>
    </div>
  );
};

export default GenericSlideThumb;
